var IgrMultiColumnComboBoxValueChangedEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrMultiColumnComboBoxValueChangedEventArgs() {
    }
    Object.defineProperty(IgrMultiColumnComboBoxValueChangedEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: false,
        configurable: true
    });
    IgrMultiColumnComboBoxValueChangedEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrMultiColumnComboBoxValueChangedEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    Object.defineProperty(IgrMultiColumnComboBoxValueChangedEventArgs.prototype, "oldValue", {
        get: function () {
            return this.i.oldValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrMultiColumnComboBoxValueChangedEventArgs.prototype, "newValue", {
        get: function () {
            return this.i.newValue;
        },
        enumerable: false,
        configurable: true
    });
    return IgrMultiColumnComboBoxValueChangedEventArgs;
}());
export { IgrMultiColumnComboBoxValueChangedEventArgs };
//# sourceMappingURL=igr-multi-column-combo-box-value-changed-event-args.js.map
